export const SATH = [
    {
        id: 1,
        role:'FRONTEND DEVELOPER',
        Company: 'Signal Alliance Technology Holding',
        date: 'Jan 2022-Present',
        task:[
            'Responsible for building the user interface and developing frontend architecture on various client projects using several technologies (mainly React.js).',
            'Was part of the team that built the Customer support portal for Cloud SA Africa. where i integrated i chat-bot feature to help make navigating through the website more seamless',
            'Ensuring proper documentation and reports in all stages of product life cycles.'
        ]
    }
]

export const USA = [
    {
        id: 1,
        role:'FRONTEND DEVELOPER (volunteer)',
        Company: 'United States of Africa',
        date: 'Dec 2021-Present',
        task:[
            "I pride in my ability to be able to quickly adapt and start working on the codebase under a short period of time",
            'I ensured that my codes are performant, maintainable and readable for other developers in the team to be able to read and work with.',
            'Work with a variety of different languages, platforms, frameworks, and content management systems such as JavaScript, TypeScript, Next, React, Craft, and Netlify',
            'Communicate with multi-disciplinary teams of engineers, designers, producers, and clients on a daily basis'
        ]
    }
]

export const CODEWARE = [
    {
        id: 1,
        role:'FRONT‑END DEVELOPER INTERN',
        Company: 'CODEWARE NIGERIA',
        date: 'Aug 2021 – Dec 2021',
        task:[
            'Developed web pages for PERXELS DESIGN SCHOOL using an internal content management system. Worked with the team that built the company website',
            'Helped in converting wire-frames, mock-ups and prototypes for products into functional and scale-able web Applications and seeing them to deployment.',
            'Testing and Debugging: Learnt the entire process of software development Lifecycle(SDLC), and also helped senior Engineers to carry out unit testing and debugging.'
        ]
    }
]